export function assertDefined<T>(value: T | undefined, errorMessage?: string): T {
    if (typeof value === "undefined") {
        throw new Error(errorMessage ?? "Expected value to be defined.");
    }
    return value;
}
